import * as React from 'react';
import './ImageBanner.scss';
import SearchBar from '../SearchBar';
import { RouteComponentProps } from 'react-router';
import { IResetSearchBar } from '../SearchBar/SearchBar';
import i18n from 'src/translation/i18n';
// import bannerImage from 'src/assets/searchBannerImage';

interface IImageBannerProps extends RouteComponentProps {
  handleOnSubmitSearch(searchText: string): void;
  handleOnSearchSelectedPart(searchText: string): void;
  handleOnSearchSelectedModel(name: string, manufacturer: string): void;
  shouldShowSearchDropdown?: boolean;
  scrolled: boolean;
}

class ImageBanner extends React.Component<IImageBannerProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      resetSearchbar: { update: false, value: false },
      scrolled: false
    };
  }

  public componentWillMount() {
    window.addEventListener('scroll', this.handlescroll);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handlescroll);
  }

  public handlescroll = () => {
    const isTop = window.scrollY < 50;
    if (isTop !== true) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  };

  public componentDidMount() {
    const update = !this.state.resetSearchbar.update;
    this.setState({
      actualUrl: this.props.location,
      resetSearchbar: { update, value: true }
    });
  }

  public componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.actualUrl !== this.props.location) {
      const update = !this.state.resetSearchbar.update;
      this.setState({
        resetSearchbar: { update, value: true },
        actualUrl: this.props.location
      });
    }
  }

  public setResetSearchbar = (value: IResetSearchBar) => {
    this.setState({ resetSearchbar: value });
  };
  public render() {
    return (
      // {this.state.isMobile && (
      <div
        className={
          'searchBox'
        }
      >
        <div className="searchBox">
          <p className="searchBoxText">
            {i18n.t('common.imageBannerSearchTxt')}
          </p>
          <SearchBar
            resetSearchbar={this.state.resetSearchbar}
            setResetSearchbar={this.setResetSearchbar}
            location={this.props.history.location}
            handleOnSubmitSearch={this.props.handleOnSubmitSearch}
            handleOnSelectedPart={this.props.handleOnSearchSelectedPart}
            handleOnSelectedModel={this.props.handleOnSearchSelectedModel}
            shouldShowItems={this.props.shouldShowSearchDropdown}
            placeholder={i18n.t('common.bannerSearchPlaceHolder')}
            aria-label={"Search millions of parts and models" }
          />
        </div>
      </div>
      // )};
    );
  }
}
export default ImageBanner;
